define('OutSystems/ReactView/LocationUtils',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isBackNavigation = exports.calculateNextLocationAge = void 0;
    exports.calculateNextLocationAge = function (nextLocationAge, nextLocationHash, action, currentAge) {
        switch (action) {
            case "PUSH":
                return currentAge + 1;
            case "POP":
                var isHashNavigation = !!nextLocationHash && !nextLocationAge;
                if (isHashNavigation) {
                    return currentAge + 1;
                }
                else {
                    return nextLocationAge !== null && nextLocationAge !== void 0 ? nextLocationAge : 0;
                }
            case "REPLACE":
                return currentAge;
            default:
                throw new Error("Missing case for " + action + " in setLocationAge");
        }
    };
    exports.isBackNavigation = function (nextLocationAge, action, currentAge) {
        switch (action) {
            case "POP":
                return currentAge >= nextLocationAge;
            case "PUSH":
            case "REPLACE":
                return false;
            default:
                throw new Error("Missing case for " + action + " in isBackNavigation");
        }
    };
});
//# sourceMappingURL=LocationUtils.js.map;
